__webpack_require__.p = "https://kettlepal.netlify.app/";